// extracted by mini-css-extract-plugin
export default {"books-list":"BooksList_books-list__MydtO"};